<template>
    <div>
         <nav-bar-main></nav-bar-main>

         <!-- Modal for manage user notifications -->
         <manage-user-notifications :plant="plantDetails" :user="UserNotifications" v-model="modalManageUserNotifications" @hide="resetManageUserNotifications"/>  

         <Loader />  
         <div v-if="inviti != null" class="animated fadeIn">
            <b-row > 
                
                <!-- banner nessun cliente presente per l'impianto -->
                <b-alert v-if=" !this.hasClient() && (ruoloUtente(currentIdUser) == 'installer' || ruoloUtente(currentIdUser) == 'admin')" show variant="info" style="display:inline-block;width:100%">
                    <manage-client></manage-client>
                </b-alert>
                <b-col v-else cols="12" class="mt-3">
                </b-col>    
  
                <!-- titolo e button invita utenti --> 
                <b-col cols="6">
                    <div id="title-first" class="ml-5 mt-2 typo-label">
                        <i class="fa fa-cog pr-1 pt-1 fa-1x pull-left"></i>
                        <span>{{$t("settings.title")}}: <b>{{$t("settings.users")}}</b></span>
                    </div>
                </b-col>
                
                <b-col cols="6">
                        <b-button v-if="this.ruoloUtente(this.currentIdUser)!='collab' && this.ruoloUtente(this.currentIdUser)!='collab_ro' && this.ruoloUtente(this.currentIdUser)!='delegate'" class="mr-4 pull-right noborder-button"  v-b-toggle.sidebar-invito >
                            <i class="fas fa fa-1x fa-plus mr-2 no-border"></i>
                            {{$t("settings.inviteButton")}}
                        </b-button>

                         <!-- drawer laterale --> 
                        <b-sidebar id="sidebar-invito" ref="sidebarInvito" :title='$t("settings.inviteTitle")' shadow close-label="close" header-class="sidebar-title" right backdrop width="500px" @hidden="clearInput">
                      
                            <!-- footer -->
                            <template v-slot:footer>
                                <div v-if="clientDefined && ruoloUtente(currentIdUser)=='installer'" class="d-flex align-items-center px-3 py-5">
                                    <b-button variant=link @click="readModalInformativa()">{{$t("settings.normaRead")}}</b-button>
                                </div>
                            </template>

                            <div v-for="(item,pos) in this.items" :key="pos" class="px-3 py-2 mt-2">
                               <b-row>
                                    <b-col cols="5">
                                        <b-form-input  v-model="item.mailInvitato" type="email" :placeholder='$t("settings.insertMail")'></b-form-input>
                                    </b-col>
                                    <b-col cols="4"> 
                                        <b-form-select v-model="item.roleInvitato" class="ml-1" style="background-color:#F6F6F6">
                                            <b-form-select-option :value="null">{{$t("settings.selectRole")}}</b-form-select-option>
                                            <b-form-select-option v-if="ruoloUtente(currentIdUser) == 'installer' || ruoloUtente(currentIdUser) == 'admin'" value="collaboratore">{{$t("settings.selectCollaboratore")}}</b-form-select-option>
                                            <b-form-select-option v-if="ruoloUtente(currentIdUser) == 'installer' || ruoloUtente(currentIdUser) == 'admin'" value="collaboratore_ro">{{$t("settings.selectCollaboratoreRO")}}</b-form-select-option>
                                            <b-form-select-option v-if="ruoloUtente(currentIdUser) == 'installer' || ruoloUtente(currentIdUser) == 'admin' && clientDefined==false" value="cliente">{{$t("settings.selectProprietario")}}</b-form-select-option>
                                            <b-form-select-option v-if="ruoloUtente(currentIdUser) == 'client' || ruoloUtente(currentIdUser) == 'admin'" value="delegato">{{$t("settings.selectDelegato")}}</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col cols="1">   
                                        <b-button @click="function(){items.splice(pos)}"><i class="fa fa-times pt-1"></i></b-button>
                                    </b-col>  
                                    <b-col cols="2">                                        
                                        <b-button v-if="ruoloUtente(currentIdUser) == 'installer' || ruoloUtente(currentIdUser) == 'admin'" :content="$t('settings.infoInstaller')" v-tippy="{ placement : 'bottom',  arrow: true }"><img src="img/info.svg" /></b-button>
                                        <b-button v-if="ruoloUtente(currentIdUser) == 'client' || ruoloUtente(currentIdUser) == 'admin'" :content="$t('settings.infoClient')" v-tippy="{ placement : 'bottom',  arrow: true }"><img src="img/info.svg" /></b-button>
                                    </b-col>
                                </b-row>     
                            </div> 

                                    <b-button class="mr-1 pull-right noborder-button mt-3" style="color: #0090CD" @click="addInput">
                                        <i class="fas fa fa-1x fa-plus mr-2 no-border"></i>
                                        {{$t("settings.addInvite")}}
                                    </b-button>
                            
 
                                <b-button class="typo-butt-add mt-4 ml-4 but-add px-5"  @click="mandaInviti">
                                    {{$t("settings.inviteUsers")}}
                                </b-button>
                                
                        </b-sidebar>
                        
                </b-col>
            </b-row>

            <!-- sezione inviti --> 
            <b-row v-if="this.ruoloUtente(this.currentIdUser)!='collab' && this.ruoloUtente(this.currentIdUser)!='collab_ro' && this.ruoloUtente(this.currentIdUser)!='delegate'">
                <b-col cols="12" >
                    <div v-if="inviti.length>0" id="title-inviti" class="ml-5 mt-3 typo-label">
                        <span><b>{{$t("settings.invite")}}</b></span>
                    </div>
                    <b-card v-for="invito in inviti" :key="invito.invite_id" class="mx-5 mt-2 radius-card" id="card-inviti">
                        <b-row>
                            <b-col class="my-auto col-9 col-sm-5 col-lg-4">
                                 <label class="emailInvito">{{invito.email}}</label> 
                            </b-col> 
                            <b-col class="my-auto col-3 col-sm-1 col-lg-1">
                                <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none" no-caret right>
                                    <template slot="button-content">
                                        <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                                    </template>
                                    <b-dropdown-item @click="eliminaInvito(invito.invite_id)">{{$t("settings.delete")}}</b-dropdown-item>
                                </b-dropdown> 
                            </b-col>   
                            <b-col class="my-auto col-5 col-sm-6 col-lg-4">
                                <span class="labelInvito"><b>{{$t("settings.inviteDate")}} {{moment(invito.dateRequest,'YYYY-MM-DD').format('DD-MM-YYYY')}}</b></span><br/>
                                <span class="dataInvitoScaduto" v-if="invitoScaduto(invito)">{{$t("settings.inviteExpired")}} {{moment(invito.dateRequest,'YYYY-MM-DD').add('months',1).format('DD-MM-YYYY')}}</span>
                                <span class="dataInvito" v-else>{{$t("settings.inviteExpirationDate")}} {{moment(invito.dateRequest,'YYYY-MM-DD').add('months',1).format('DD-MM-YYYY')}}</span>
                            </b-col> 
                            <b-col class="my-auto col-10 col-sm-5 col-lg-3">
                                <span class="tipoRuolo" :content="tagRuolo(invito.role)" v-tippy="{ placement : 'top',  arrow: true }"> <i class="fa fa-info-circle" ></i> {{tipoRuolo(invito.role)}}</span> 
                            </b-col> 
                        </b-row>        
                        
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <!-- sezione utenti --> 
                <b-col cols="12 mb-5" id="sezione-utenti">
                    <div id="title-utenti" class="ml-5 mt-2 typo-label">
                        <span><b>{{$t("settings.users")}}</b></span>
                    </div>
                    <b-card v-for="utente in plantUsersFiltered" :key="utente.id" class="mx-5 mt-2 radius-card" id="card-utenti">                    
                        <b-row>
                            <b-col class="my-auto col-9 col-sm-5 col-lg-4">
                                <div style="display: flex; justify-content: flex-start; align-items: center">
                                <avatar   
                                    :username="utente.name + ' ' + utente.surname"
                                    background-color="#04709C"
                                    :size="35"
                                    :rounded="true"
                                    color="#FFFFFF"
                                    class="p-4 mr-3"
                                ></avatar>
                                    <!-- <img class="userAvatar" /> -->
                                    <i v-if="ruoloUtente(utente.id) == 'installer'" class="fa fa-user-circle avatarInstaller"></i>
                                    <i v-if="ruoloUtente(utente.id) == 'client'" class="fa fa-star avatarClient"></i> 
                                    <div>
                                        <span class="emailInvito">{{utente.name}} {{utente.surname}}</span><br/>
                                        <span class="dataInvito">{{utente.businnesname}}</span>
                                    </div>
                                </div>
                            </b-col> 
                            <b-col class="my-auto col-3 col-sm-1 col-lg-1">
                                <b-dropdown v-if="ruoloUtente(currentIdUser)=='installer' || ruoloUtente(currentIdUser)=='admin'" variant="link" size="lg" toggle-class="text-decoration-none" no-caret right>
                                    <template slot="button-content">
                                        <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                                    </template>
                                    <b-dropdown-item v-if="ruoloUtente(utente.id) != 'installer' && ruoloUtente(utente.id) != 'client'"  @click="eliminaUtente(utente)">{{$t("settings.delete")}}</b-dropdown-item>
                                    <b-dropdown-item  @click="showManageUserNotifications(utente)">{{$t("manage_notification_modal.title")}}</b-dropdown-item>
                                </b-dropdown> 
                            </b-col>   
                            <b-col class="my-auto col-12 col-sm-6 col-lg-4">
                                <span class="dataInvito">{{utente.username}}</span><br/>
                                <span class="dataInvito">{{utente.phone}}</span>
                            </b-col> 
                            <b-col class="my-auto col-12 col-sm-5 col-lg-3">
                            <span class="tipoRuolo" :content="tagRuolo(ruoloUtente(utente.id))" v-tippy="{ placement : 'top',  arrow: true }"> <i class="fa fa-info-circle" ></i> {{tipoRuolo(ruoloUtente(utente.id))}}</span> 
                            </b-col> 
                        </b-row>      
                        
                    </b-card>
                </b-col>
            </b-row>   
         </div>

        <!-- Modal accettazione informativa installatore versus cliente-->
        <b-modal
            ref="modalInformativa"
            id="modal-informativa"
            size="lg"
            :title="$t('settings.normaTitle')"
            :ok-title="$t('settings.normaAccept')"
            @ok="accettazioneNomina"
        >
            <label for="typo-label">
            <accettazione-nomina-ITA v-if="$t('language')=='IT'"></accettazione-nomina-ITA>
            <accettazione-nomina-ENG v-else></accettazione-nomina-ENG>
            </label>
        </b-modal>

        <!-- Modal leuura informativa installatore -->
        <b-modal
            ref="readModalInformativa"
            id="modal-read-informativa"
            size="lg"
            title=""
            :hide-footer="true"
            :ok-title="$t('settings.normaAccept')"
            @ok="accettazioneNomina"
        >
            <label for="typo-label">
            <accettazione-nomina-ITA v-if="$t('language')=='IT'"></accettazione-nomina-ITA>
            <accettazione-nomina-ENG v-else></accettazione-nomina-ENG>
            </label>
        </b-modal>
  </div>
</template>

        
    </div>
</template>


<script>

import Vue from 'vue';
import NavBarMain from '@/components/NavBarMain';
import AccettazioneNominaITA from '@/locales/AccettazioneNominaITA';
import AccettazioneNominaENG from '@/locales/AccettazioneNominaENG';
import ManageUserNotifications from './ManageUserNotifications.vue';
import Avatar from 'vue-avatar';
import ManageClient from '@/components/ManageClient';
import { mapState } from 'vuex';


export default {
    name: 'UtentiImpianto',
    components: {
        NavBarMain,
        Avatar,
        AccettazioneNominaITA,
        AccettazioneNominaENG,
        ManageClient,
        ManageUserNotifications
    },
    data() {
        return {
            items:[
                {
                    mailInvitato: '',
                    roleInvitato: null
                }
                ],
            options: [
                { value: 'a', text: 'This is First option' }
            ],  
            modalManageUserNotifications: false,
            UserNotifications:null,
            inviti: null,
            currentInvite : null,
            invitingDelegato: false,
            invitingCliente: false,
            invitingCollab: false,
            selected:"", 
            plantUsers: null,
            plantUsersFiltered: null,
            plantId: null,
            emailInvitato: "",
            ruoloInvitato: "",
            currentIdUser: "",
            clientDefined: false,
            sendInvite: false,
            reg: /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,30})$/ 
        }
    },
    computed: {
        ...mapState(['commandResponse','error','loading']),
        plantDetails() {
            const plant = this.$store.state.currentPlant;
            console.log("PLANT DETAILS",plant);
            if (plant == null) return null;
            //if (plant.id != this.plantId) return null;
            return plant;
        }
    },  
    mounted() {
            this.init();
    },
    updated() {

        },
    watch: {
          loading(val,oldval) {
            console.log("loading changed:" + val+", error=" + this.error+", loop=" + this.loop);
            if (this.plantDetails==null)
            {
                this.$store.dispatch('loadPlantDetails', this.$route.params.plantId);
            }
            else
            {
                if(this.inviti==null)
                {
                   this.$store.dispatch('getListaInviti', {plantId: this.$route.params.plantId});

                    let listaUsers = this.$store.state.currentPlant.plant_users;
                    
                    if (listaUsers == null || listaUsers.length == 0) {
                        this.plantUsers = [];
                    } else {
                        let listaIds = listaUsers.map(function(u) {
                            return u.userid;
                        });
                        this.$store.dispatch('getPlantUsers', {userIds: listaIds});
                    }
                }
            }
          },
        commandResponse(val,oldval) {
            console.log("updated commandResponse utenti:",val);
            if (val.command == 'listaInviti' && val.pending == false) {
                let self = this;
                let role = this.$store.getters.userRole;
                this.inviti = val.response.data.filter(function(value){
                    if (role == 'installer') {
                        return (value.role == 'client' || value.role == 'collab' || value.role == 'collab_ro');
                    } else if (role == 'client') {
                        return (value.role == 'delegate');
                    }
                    return false;
                }).sort(function(a,b) {
                    return new Date(a.dateRequest) - new Date(b.dateRequest);
                });
                console.log("aggiornato inviti:" + this.inviti.length);
            } else if (val.command == 'eliminaInvito' && val.pending == false) {
                this.inviti = this.inviti.filter(function(value) {
                    return value.invite_id != val.response.data.invite_id;
                });    
            } else if (val.command == 'nominaAccepted'&& val.pending == false) {
                this.invitaCliente();       
            } else if (val.pending == false && (val.command == 'invitaCollab' || val.command == 'invitaCliente' || val.command == 'invitaDelegato')) {
                    this.invitingCollab = false;
                    this.invitingCliente = false;
                    this.invitingDelegato = false;
                    if (val.response.data) {
                        this.$bvModal.msgBoxOk(this.$t("settings.inviteSuccess"), {
                        title: this.$t('settings.operationSuccess'),
                        okVariant: 'success',
                        centered: true
                        });
                        this.init();
                    } else {
                        this.$bvModal.msgBoxOk('Si è verificato un errore:\n' + val.response.error, {
                        title: 'Errore',
                        okVariant: 'danger',
                        centered: true
                        });
                    }
            } else if (val.pending == false && (val.command == 'rimuoviDelegato' || val.command == 'rimuoviCollaboratore'))
            {
                let listaUsers = this.$store.state.currentPlant.plant_users;
                let listaIds = null;    
                if (listaUsers == null || listaUsers.length == 0) {
                    this.plantUsers = [];
                } else {
                    listaIds = listaUsers.map(function (u) {
                        return u.userid;
                    });
                }
               this.$store.dispatch('getPlantUsers', {userIds: listaIds});
            }  else if (val.pending == false && val.command == 'saveNotificationsOnProfile') {
               console.log("saved notifications: ",val);
               if (val.data!=false)
                this.init();
            }
            else if (val.command == 'getPlantUsers' && val.pending == false) {
                let role = this.$store.getters.userRole;
                this.plantUsers = val.response.data;
                
                this.plantUsersFiltered=[];
                var userFilt;

                this.currentIdUser=this.$store.getters.userId;

                console.log("LISTA CURRENT ROLE ID, ROLE", this.currentIdUser,this.ruoloUtente(this.currentIdUser));

                //filtered role from users
                for (var m=0; m<this.plantUsers.length; m++)
                {
                    if (this.currentIdUser == this.plantUsers[m].id)
                    {
                         userFilt=this.plantUsers[m];
                         userFilt.role=this.ruoloUtente(this.plantUsers[m].id);
                         this.plantUsersFiltered.push(userFilt);     
                    }

                    if (this.ruoloUtente(this.currentIdUser) == 'installer' && this.ruoloUtente(this.plantUsers[m].id)!= 'delegate' && this.ruoloUtente(this.plantUsers[m].id)!= 'installer')
                    {
                         userFilt=this.plantUsers[m];
                         userFilt.role=this.ruoloUtente(this.plantUsers[m].id);
                         this.plantUsersFiltered.push(userFilt);     
                    }

                    else if (this.ruoloUtente(this.currentIdUser) == 'client' && this.ruoloUtente(this.plantUsers[m].id)!= 'collab' && this.ruoloUtente(this.plantUsers[m].id)!= 'client')
                    {
                         userFilt=this.plantUsers[m];
                         userFilt.role=this.ruoloUtente(this.plantUsers[m].id);
                          this.plantUsersFiltered.push(userFilt);     
                    }
                    
                    else if (this.ruoloUtente(this.currentIdUser) == 'collab' && this.ruoloUtente(this.plantUsers[m].id)!= 'delegate' && this.ruoloUtente(this.plantUsers[m].id)!= 'collab' && this.ruoloUtente(this.plantUsers[m].id)!= 'client')
                    {
                         userFilt=this.plantUsers[m];
                         userFilt.role=this.ruoloUtente(this.plantUsers[m].id);
                          this.plantUsersFiltered.push(userFilt);     
                    }

                   else if (this.ruoloUtente(this.currentIdUser) == 'delegate'  && this.ruoloUtente(this.plantUsers[m].id)!= 'delegate' && this.ruoloUtente(this.plantUsers[m].id)!= 'collab' && this.ruoloUtente(this.plantUsers[m].id)!= 'installer')
                    {
                         userFilt=this.plantUsers[m];
                         userFilt.role=this.ruoloUtente(this.plantUsers[m].id);
                         this.plantUsersFiltered.push(userFilt);     
                    }

                    else if (this.ruoloUtente(this.currentIdUser) == 'admin')
                    {
                         userFilt=this.plantUsers[m];
                         userFilt.role=this.ruoloUtente(this.plantUsers[m].id);
                         this.plantUsersFiltered.push(userFilt);     
                    }

                    if (this.ruoloUtente(this.plantUsers[m].id)== 'client')
                    {
                        this.clientDefined=true;
                    }
                }

                console.log("ROLE FILTERED", this.plantUsersFiltered);
            }


        }
    },
    
    methods: {
        init(){
          console.log("MOUNTED");
          this.currentIdUser=this.$store.getters.userId;
          //console.log("USER",this.$store.getters.userId);
          this.plantId = this.$route.params.plantId;
          console.log("homeImpianto mounted, idImpianto=" + this.plantId);
          console.log("PlantDetails",this.plantDetails);
          
          if(this.plantDetails!=null)
          {
            this.$store.dispatch('getListaInviti', {plantId: this.$store.state.currentPlant.id});
            let listaUsers = this.$store.state.currentPlant.plant_users;
         
            if (listaUsers == null || listaUsers.length == 0) {
              this.plantUsers = [];
            } else {
              let listaIds = listaUsers.map(function(u) {
                  return u.userid;
              });
              this.$store.dispatch('getPlantUsers', {userIds: listaIds});
            }
          }
        },
        clearInput()
        {
         this.items=[
                {
                    mailInvitato: '',
                    roleInvitato: null
                }
                ];   
        }, 
        addInput()
        {
         var newItem={ mailInvitato: '', roleInvitato: null};
         this.items.push(newItem);   
        },
        readModalInformativa()
        {
            this.$refs['readModalInformativa'].show();
        }, 
        showModalInformativa()
        {
            var acceptedDate= new Date(this.$store.state.user.nominaAccepted);
            if (acceptedDate.getFullYear()>2019 && acceptedDate.getFullYear()<2200)
            {
                console.log("Nomina già accettata in data",acceptedDate);
                this.invitaCliente();
            }
            else
            {
                this.$refs['modalInformativa'].show();
            }    
        },
        accettazioneNomina()
        {
           var actualDate=new Date();
           console.log("Dispatch accettazione nomina",actualDate);
           this.$store.dispatch('dbSaveNomina',{acceptedDate: actualDate});
        },
        invitaCliente()
        {
            this.$store.dispatch('invitaCliente',{plantId: this.plantId,plantName: this.plantDetails.plantname, email: this.currentInvite});
            this.invitingCliente=true;
            console.log("accettata normativa ");
        },
        mandaInviti() 
        {
            for (var k=0;k<this.items.length;k++)
                {
                    if(this.items[k].mailInvitato.length>0 && this.reg.test(this.items[k].mailInvitato) && this.items[k].roleInvitato=="cliente")
                    {
                        console.log("MANDO INVITO CLIENTE", this.items[k].mailInvitato, this.plantId, this.plantDetails.plantname);
                        this.currentInvite=this.items[k].mailInvitato;
                        this.showModalInformativa(); 
                    }
                    else if(this.items[k].mailInvitato.length>0 && this.reg.test(this.items[k].mailInvitato) && this.items[k].roleInvitato=="collaboratore")
                    {
                        console.log("MANDO INVITO COLLABORATORE", this.items[k].mailInvitato, this.plantId, this.plantDetails.plantname);
                        this.invitingCollab = true;
                        this.$store.dispatch('invitaCollaboratore',{plantId: this.plantId,plantName: this.plantDetails.plantname, email: this.items[k].mailInvitato, readOnly: false});
                    }
                    else if(this.items[k].mailInvitato.length>0 && this.reg.test(this.items[k].mailInvitato) && this.items[k].roleInvitato=="collaboratore_ro")
                    {
                        console.log("MANDO INVITO COLLABORATORE READONLY", this.items[k].mailInvitato, this.plantId, this.plantDetails.plantname);
                        this.invitingCollab = true;
                        this.$store.dispatch('invitaCollaboratore',{plantId: this.plantId,plantName: this.plantDetails.plantname, email: this.items[k].mailInvitato, readOnly: true});
                    }
                    else if(this.items[k].mailInvitato.length>0 && this.reg.test(this.items[k].mailInvitato) && this.items[k].roleInvitato=="delegato")
                    {
                        console.log("MANDO INVITO DELEGATO", this.items[k].mailInvitato, this.plantId, this.plantDetails.plantname);
                        this.invitingDelegato = true;
                        this.$store.dispatch('invitaDelegato',{plantId: this.plantId,plantName: this.plantDetails.plantname, email: this.items[k].mailInvitato});
                    }
                    else
                    {
                        this.$bvModal.msgBoxOk(this.$t("settings.mailInviteEmpty"), {
                        title: this.$t("settings.danger"),
                        okVariant: 'danger',
                        centered: true
                        });
                    }
                }
                this.$refs['sidebarInvito'].hide();  
        },
    
        rimuoviDelegato(collabId, nome) {
        this.$bvModal.msgBoxConfirm(this.$t("settings.userDelete") + " " + nome, {
            title: this.$t("settings.userDeleteTitle"),
            centered: true,
            okTitle: this.$t("settings.remove"),
            cancelTitle: this.$t("settings.cancel"),
            okVariant: "danger"
        }).then(value => {
            if (value) {
            console.log("rimuovo delegato " + collabId);
            this.$store.dispatch('rimuoviDelegato',{plantId: this.plantDetails.id,userId: collabId});
            }
        });
        },
        eliminaUtente(User) {
            console.log("Rimuovi user ", User.id + " " + User.name + " " + this.ruoloUtente(User.id));
            if (this.ruoloUtente(User.id) == "collab" || this.ruoloUtente(User.id) == "collab_ro")
            {
                this.rimuoviCollab(User.id, User.name, User.surname);
            }
            if (this.ruoloUtente(User.id) == "delegate") this.rimuoviDelegato(User.id, User.name);
        },
        showManageUserNotifications(userNot)
        {
           this.UserNotifications=userNot;
           this.modalManageUserNotifications = true;
           console.log("Current user to set", this.UserNotifications);
        },
        resetManageUserNotifications() {
            this.manageUserNotifications=null;
        },
        rimuoviCollab(collabId, nome, cognome) {
            console.log("rimuovo collaboratore " + collabId);
        this.$bvModal.msgBoxConfirm(this.$t("settings.userDelete") + " " + nome + " " + cognome, {
            title: this.$t("settings.userDeleteTitle"),
            centered: true,
            okTitle: this.$t("settings.remove"),
            cancelTitle: this.$t("settings.cancel"),
            okVariant: "danger"
        }).then(value => {
            if (value) {
            console.log("rimuovo collaboratore " + collabId);
            this.$store.dispatch('rimuoviCollaboratore',{plantId: this.plantDetails.id,userId: collabId});
            }
        });
        },
        invitoScaduto(invito) {
            return this.moment().isAfter(this.moment(invito.dateRequest,'YYYY-MM-DD').add('months',1));
        },
        ruoloUtente(id) {

            let pusers = this.$store.state.currentPlant.plant_users;
            if (pusers == null || pusers.length == 0) return "?";
            let user = pusers.filter(function(u){
                return u.userid == id;
            });
            if (user != null && user.length > 0) return user[0].role;
            return "admin";
        },
        hasClient(){

            return this.plantDetails != null && this.plantDetails.clientData != null;

            /*for(var j=0; j<this.plantDetails.plant_users.length; j++)
            {
                if (this.plantDetails.plant_users[j].role=="client")
                    return true
            }
            return false*/
        },
        tipoRuolo(tipo) {
            var roleName="";
            switch(tipo) {
                case 'client':
                    roleName= this.$t("settings.selectProprietario");
                    return roleName;
                case 'collab':
                    roleName=this.$t("settings.selectCollaboratore");
                    return roleName;
                case 'collab_ro':
                    roleName=this.$t("settings.selectCollaboratoreRO");
                    return roleName;
                case 'delegate':
                    roleName=this.$t("settings.selectDelegato");
                    return roleName;
                case 'installer':
                    roleName=this.$t("settings.selectAmministratore");
                    return roleName;
            }
            return tipo;
        },
        tagRuolo(tipo) {
            var roleTag="";
            switch(tipo) {
                case 'client':
                    roleTag= this.$t("settings.Cliente Proprietario");
                    return roleTag;
                case 'collab':
                    roleTag=this.$t("settings.Installatore Staff");
                    return roleTag;
                case 'collab_ro':
                    roleTag=this.$t("settings.Installatore Staff ReadOnly");
                    return roleTag;
                case 'delegate':
                    roleTag=this.$t("settings.Cliente Staff");
                    return roleTag;
                case 'installer':
                    roleTag=this.$t("settings.Installatore Amministratore");
                    return roleTag;
            }
            return tipo;
        },
        eliminaInvito(id) {
            console.log("elimino invito " + id);

             this.$bvModal.msgBoxConfirm(this.$t("settings.inviteDelete"), {
                title: this.$t("settings.inviteDeleteTitle"),
                centered: true,
                okTitle: this.$t("settings.delete"),
                cancelTitle: this.$t("settings.cancel"),
                okVariant: "danger"
            }).then(value => {
                if (value) {
                console.log("rimuovo invito " + id);
                this.$store.dispatch('eliminaInvito',{invite_id: id, plantId: this.$store.state.currentPlant.id});
                }
            });

        }
    }
}

</script>

<style lang="scss">

#inviteUserSidebar > div.modal-dialog {
    height: 100% !important;
    position: absolute;
    right: 0px;
    width: 500px;
    margin: 0;
    padding-top: 154px;
}

#inviteUserSidebar div.modal-content {
    
    height: auto;
    min-height: 100%;
    border-radius: 0;
}

#inviteUserSidebar header.modal-header {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    
}

#sidebar-invito {
    background-color: #FFFFFF !important
}

@media screen and (max-width: 767px) {
    #title-first{
        margin-left: 1rem !important;
    }
    #title-utenti{
        margin-left: 1rem !important;
    }
    #title-inviti{
        margin-left: 1rem !important;
    }
    #sezione-utenti{
        margin-bottom: 4rem !important;
    }
    #card-utenti{
        margin-left: 0rem !important;
        margin-right: 0rem !important;
    }
    #card-inviti{
        margin-left: 0rem !important;
        margin-right: 0rem !important;
    }
}

</style>